<template>
  <div>
    <section class="hc-banner">
      <ol>
        <li v-for=" ( item , index ) in data" :key="index" :class=" { red : index == dataid } "></li>
      </ol>
      <ul class="banner">
        <transition-group name="fade">
          <li
            class="hc-bannerbg"
            v-for="(item,index) in data"
            v-show="index==dataid"
            :key="index"
            :style="{'background-image' : `url(${item})`}"
          ></li>
        </transition-group>
      </ul>

      <!-- <a class="btn left">&lt;</a>
      <a class="btn right">&gt;</a>-->
    </section>
  </div>
</template>

<script>
export default {
  name: "banner",
  props: {
    imgarry: Array
  },
  data() {
    return {
      data: this.imgarry,
      dataid: 0,
      timers: null
    };
  },
  created() {
    if (this.imgarry.length == 1) {
      this.dataid = 0;
    }
  },
  mounted() {
    this.timers = setInterval(this.changTime, 5000);
  },
  methods: {
    changTime() {
      var id = this.dataid;
      if (id < this.data.length - 1) {
        id++;
      } else {
        id = 0;
      }
      this.dataid = id;
    }
  },
  destroyed() {
    clearInterval(this.timers);
    //this.timers = null
  }
};
</script>

<style scoped>
.hc-banner {
  margin: 0 auto;
  height: 436px;
  width: 1600px;
  overflow: hidden;
  position: relative;
  animation: mune-in 1s;
}
@keyframes mune-in {
  0% {
    transform: scale(0);
    opacity: 0;
  }
  100% {
    opacity: 1;
    transform: scale(1);
  }
}
.banner li {
  width: 1600px;
  height: 436px;
  position: absolute;
  left: 0;
  top: 0;
  background-position: center;
  background-size: cover;
  overflow: hidden;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 1s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

ol {
  position: relative;
  display: table;
  margin: 0 auto;
  top: 400px;
  z-index: 10;
}
ol li {
  list-style: none;
}
ol li {
  float: left;
  width: 12px;
  height: 12px;
  margin: 0 7px;
  border: 1px solid #fff;
  border-radius: 7px;
}
ol li.red {
  background: #fff;
}
</style>
